import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./index.css";

// 🟢 Supabase auth provider
import { SessionContextProvider } from "@supabase/auth-helpers-react";
import { supabase } from "@/lib/supabase";

// (optional) your error boundary if you use one
import ErrorBoundary from "@/components/dev/ErrorBoundary"; // remove if you don't have it

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SessionContextProvider supabaseClient={supabase} initialSession={null}>
      {/* BrowserRouter must be inside the provider so hooks work everywhere */}
      {/* If you do NOT have ErrorBoundary, remove the two ErrorBoundary tags */}
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </SessionContextProvider>
  </React.StrictMode>
);
